import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdAddCompanyButtonModule } from '@sdvor/company/ui';
import {
  DropdownComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  DropdownTogglerComponent,
} from '@sdvor/shared/ui/v2';
import { SdCheckoutSwitchProfileComponent } from './checkout-switch-profile.component';

@NgModule({
  declarations: [SdCheckoutSwitchProfileComponent],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    NgClass,
    DropdownComponent,
    SdAddCompanyButtonModule,
    DropdownTogglerComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
  ],
  exports: [SdCheckoutSwitchProfileComponent],
})
export class SdvorCheckoutSwitchProfileModule {}
